import { createFileRoute } from '@tanstack/react-router';

import { PlanEquityWashTab } from '../../../../../components';

const Page = () => {
  const params = Route.useParams();
  return <PlanEquityWashTab planId={params.planId} />;
};

export const Route = createFileRoute(
  '/organizations/$advisoryOrganizationId/plans/$planId/equity-wash'
)({
  component: Page
});
